var Utils = {
  loadingScreen: function (status) {
    var containerElement = document.querySelector("body");

    if (status == "show") {
      containerElement.dataset.pendingAjaxRequestCount = String(
        (parseInt(containerElement.dataset.pendingAjaxRequestCount) || 0) + 1
      );

      if (containerElement.getAttribute("loading-screen") == "true") return;

      // create loading element
      var loadingDiv = document.createElement("div");
      loadingDiv.classList.add("loading-screen");

      containerElement.setAttribute("loading-screen", "true");
      containerElement.appendChild(loadingDiv);
      loadingDiv.classList.add("show");
    } else if (status == "hide") {
      var pendingAjaxRequestCount =
        containerElement.dataset.pendingAjaxRequestCount;

      if (pendingAjaxRequestCount && parseInt(pendingAjaxRequestCount) > 0) {
        var activeloadingDiv = document.querySelector(".loading-screen");

        containerElement.dataset.pendingAjaxRequestCount = String(
          parseInt(containerElement.dataset.pendingAjaxRequestCount) - 1
        );

        if (activeloadingDiv && pendingAjaxRequestCount == "1") {
          activeloadingDiv.classList.remove("show");
          containerElement.setAttribute("loading-screen", "false");

          setTimeout(function () {
            activeloadingDiv = document.querySelector(".loading-screen");
            if (activeloadingDiv) {
              activeloadingDiv.outerHTML = "";
            }
          }, 300);
        }
      }
    } else if (status == "show-static") {
      if (containerElement.getAttribute("loading-screen-static") == "true")
        return;

      // create loading element
      var loadingDiv = document.createElement("div");
      loadingDiv.classList.add("loading-screen");

      containerElement.setAttribute("loading-screen-static", "true");
      containerElement.appendChild(loadingDiv);
      loadingDiv.classList.add("show");
    } else if (status == "hide-static") {
      var activeloadingDiv = document.querySelector(".loading-screen");

      if (activeloadingDiv) {
        activeloadingDiv.classList.remove("show");
        containerElement.setAttribute("loading-screen-static", "false");

        setTimeout(function () {
          activeloadingDiv = document.querySelector(".loading-screen");
          if (activeloadingDiv) {
            activeloadingDiv.outerHTML = "";
          }
        }, 300);
      }
    }
  },

  downloadFile: function (data, fileName) {
    if (
      window.navigator.userAgent.match(/MSIE|Trident/) !== null ||
      window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1
    ) {
      fileName += ".xlsx";
    }
    const url = window.URL.createObjectURL(data); // for other browsers
    const anchor = document.createElement("a");
    const anchorContainer = document.querySelector("body");
    anchorContainer.appendChild(anchor);
    anchor.download = fileName;
    anchor.href = url;
    anchor.target = "_blank";
    anchor.click();
    anchor.remove();
  },
};

export default Utils;
